function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.997852,
  y: 0.45,
  width: 15.1714,
  height: 18.7429,
  rx: 0.9,
  fill: "#E9EDC4",
  stroke: "#373D49",
  strokeWidth: 0.9
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 3.04785,
  y: 4.64282,
  width: 6.07143,
  height: 1.07143,
  rx: 0.535714,
  fill: "#373D49"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 3.04785,
  y: 8.21436,
  width: 6.07143,
  height: 1.07143,
  rx: 0.535714,
  fill: "#373D49"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 3.04785,
  y: 11.7856,
  width: 6.07143,
  height: 1.07143,
  rx: 0.535714,
  fill: "#373D49"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 15.0123,
  cy: 15.8929,
  r: 5.08571,
  fill: "#E9EDC4",
  stroke: "#373D49",
  strokeWidth: 0.9
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.5479 13.3929C15.5479 13.097 15.308 12.8572 15.0122 12.8572C14.7163 12.8572 14.4764 13.097 14.4764 13.3929V15.3572L12.5123 15.3572C12.2164 15.3572 11.9766 15.597 11.9766 15.8929C11.9766 16.1888 12.2164 16.4286 12.5123 16.4286L14.4764 16.4286V18.3929C14.4764 18.6888 14.7163 18.9286 15.0122 18.9286C15.308 18.9286 15.5479 18.6888 15.5479 18.3929V16.4286L17.5123 16.4286C17.8081 16.4286 18.048 16.1888 18.048 15.8929C18.048 15.597 17.8081 15.3572 17.5123 15.3572L15.5479 15.3572V13.3929Z",
  fill: "#373D49"
});

function SvgListfav(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListfav);
export default __webpack_public_path__ + "static/media/listfav.0177d7c5.svg";
export { ForwardRef as ReactComponent };